import { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle, Lock, Clock } from 'lucide-react';
import { API_BASE } from '@/utils/api';
import { useAuth } from '@/contexts/AuthContext';

const STYLES = {
  warning: 'bg-amber-50 border-amber-300 text-amber-900',
  danger: 'bg-red-50 border-red-300 text-red-900',
  blocked: 'bg-slate-900 border-slate-900 text-white',
};
const ICONS = { warning: Clock, danger: AlertTriangle, blocked: Lock };

// Cartel de suscripción: avisos 7/3/1 días, gracia (fijo) y solo lectura (fijo)
export const SubscriptionBanner = () => {
  const { user, isAuthenticated } = useAuth();
  const [info, setInfo] = useState(null);
  const [hidden, setHidden] = useState(false);
  const hasBusiness = user && (user.role !== 'super_admin' || user.active_business_id);

  useEffect(() => {
    if (!isAuthenticated || !hasBusiness) return;
    axios.get(`${API_BASE}/subscription`).then(r => setInfo(r.data)).catch(() => {});
  }, [isAuthenticated, hasBusiness, user?.active_business_id]);

  const b = info?.banner;
  if (!b || (hidden && !b.fixed)) return null;
  const Icon = ICONS[b.level] || Clock;
  return (
    <div className={`border-b px-4 py-2.5 text-sm flex items-center gap-3 ${STYLES[b.level]} ${b.fixed ? 'sticky top-0 z-[60]' : ''}`}
      data-testid="subscription-banner" data-level={b.level} role="status">
      <Icon className="w-4 h-4 shrink-0" />
      <span className="flex-1" data-testid="subscription-banner-message">{b.message}</span>
      {!b.fixed && <button className="text-xs underline" onClick={() => setHidden(true)} data-testid="subscription-banner-close">Ocultar</button>}
    </div>
  );
};
